module.exports = __webpack_public_path__ + "static/media/icon_ceramic_metal_9.f93f0354.svg";